import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@material-ui/core"
import { useEffect, useRef, useState } from "react"

const useStyles = makeStyles(() => ({
    botaoExcluir: {
        backgroundColor: "var(--cor-erro)",
        color: "white",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
        },
    },
    botaoVoltar: {
        color: "#546e7a",
        border: "1.5px solid #cfd8dc",
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "rgba(84,110,122,0.08)",
        },
    },
    botaoSalvar: {
        backgroundColor: "#14A44D",
        color: "white",
        "&:hover": {
            backgroundColor: "#28B76C",
        },
    },
}))

export default function DialogPassoDeMontagem({
    open,
    setOpenPassoDeMontagem,
    modalPasso,
    cadastrar,
    handleCadastrarGrupoDeOpcao,
    produtoAtual,
}) {
    const classes = useStyles()

    const handleClosePassoDeMontagem = () => {
        setOpenPassoDeMontagem(false)
    }

    const id = modalPasso ? modalPasso?.id : null
    const versao = modalPasso ? modalPasso?.versao : null

    const proximaOrdemExib = cadastrar
        ? Math.max(0, ...(produtoAtual?.opcoes?.map(o => Number(o.ordemExib) || 0) ?? [])) + 1
        : (modalPasso?.ordemExib ?? 0)

    const ordemExibRef = useRef(proximaOrdemExib)
    const nomeRef = useRef(modalPasso?.nome)
    const qtdMinRef = useRef(modalPasso?.quantidadeMinima)
    const qtdMaxRef = useRef(modalPasso?.quantidadeMaxima)
    const ativoRef = useRef(modalPasso?.ativo)
    const codigoRef = useRef(modalPasso?.codigo)
    const [modoCalculo, setModoCalculo] = useState("")

    const [diaSemana, setDiaSemana] = useState(null)
    const handleChangeDiaSemana = e => {
        setDiaSemana(e.target.value)
    }
    const [adicional, setAdicional] = useState(1)
    const handleChangeAdicional = e => {
        setAdicional(e.target.value)
    }

    const handleChangeModoCalculo = e => {
        const valor = e.target.value
        setModoCalculo(valor)
    }

    useEffect(() => {
        if (!cadastrar) {
            setDiaSemana(modalPasso?.diaSemana)
            setAdicional(modalPasso?.adicional)
            setModoCalculo(
                modalPasso?.considerarMedia
                    ? "considerarMedia"
                    : modalPasso?.considerarMaiorValor
                    ? "considerarMaiorValor"
                    : "soma"
            )
        }
    }, [modalPasso])

    return (
        <>
            {open && (
                <Dialog open={open} onClose={handleClosePassoDeMontagem} maxWidth="md">
                    <DialogTitle id="alert-dialog-title">
                        {cadastrar ? "Cadastrar Passo de Montagem" : "Editar Passo de Montagem"}
                    </DialogTitle>
                    <form
                        onSubmit={e => {
                            e.preventDefault()
                            const data = {
                                id,
                                versao,

                                nome: nomeRef?.current?.value,
                                ordemExib: ordemExibRef?.current?.value,
                                quantidadeMinima: qtdMinRef?.current?.value,
                                quantidadeMaxima: qtdMaxRef?.current?.value,
                                ativo: ativoRef?.current?.checked,
                                codigo: codigoRef?.current?.value,

                                considerarMaiorValor: modoCalculo === "considerarMaiorValor",
                                considerarMedia: modoCalculo === "considerarMedia",

                                diaSemana,
                                adicional,
                            }

                            handleCadastrarGrupoDeOpcao(produtoAtual.id, data)
                            handleClosePassoDeMontagem()
                        }}
                    >
                        <DialogContent>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        label="Ordem"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="000"
                                        inputRef={ordemExibRef}
                                        defaultValue={proximaOrdemExib}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        label="Código"
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={codigoRef}
                                        defaultValue={modalPasso?.codigo}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        label="Nome"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="Ex: Escolha o Adicional"
                                        inputRef={nomeRef}
                                        defaultValue={modalPasso?.nome}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        label="Quantidade Mínima"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="000"
                                        inputRef={qtdMinRef}
                                        defaultValue={modalPasso?.quantidadeMinima}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        label="Quantidade Máxima"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="000"
                                        inputRef={qtdMaxRef}
                                        defaultValue={modalPasso?.quantidadeMaxima}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Dia da Semana</InputLabel>
                                        <Select
                                            label="Dia da Semana"
                                            value={diaSemana}
                                            onChange={handleChangeDiaSemana}
                                        >
                                            <MenuItem value={null}>Todos</MenuItem>
                                            <MenuItem value={"DOMINGO"}>Domingo</MenuItem>
                                            <MenuItem value={"SEGUNDA"}>Segunda</MenuItem>
                                            <MenuItem value={"TERCA"}>Terça</MenuItem>
                                            <MenuItem value={"QUARTA"}>Quarta</MenuItem>
                                            <MenuItem value={"QUINTA"}>Quinta</MenuItem>
                                            <MenuItem value={"SEXTA"}>Sexta</MenuItem>
                                            <MenuItem value={"SABADO"}>Sabado</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Grupo de Adicionais</InputLabel>
                                        <Select
                                            label="Grupo de Adicionais"
                                            value={adicional}
                                            onChange={handleChangeAdicional}
                                        >
                                            <MenuItem value={0}>0 - Definidor de Preço</MenuItem>
                                            <MenuItem value={1}>1 - Adiconal Optativo</MenuItem>
                                            <MenuItem value={2}>
                                                2 - Adicional Quantitativo
                                            </MenuItem>
                                            <MenuItem value={3}>3 - Adicional Digitável</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} container alignItems="center">
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Grupo de Adicionais</InputLabel>
                                        <Select
                                            label="Grupo de Adicionais"
                                            value={modoCalculo}
                                            onChange={handleChangeModoCalculo}
                                        >
                                            <MenuItem value="soma">Soma</MenuItem>
                                            <MenuItem value="considerarMaiorValor">
                                                Considerar Maior Valor
                                            </MenuItem>
                                            <MenuItem value="considerarMedia">
                                                Considerar Média
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} container alignItems="center">
                                    <Checkbox
                                        inputRef={ativoRef}
                                        defaultChecked={cadastrar ? true : modalPasso?.ativo}
                                    />
                                    <Typography>Disponível</Typography>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                className={classes.botaoVoltar}
                                onClick={handleClosePassoDeMontagem}
                            >
                                Voltar
                            </Button>
                            <Button type="submit" className={classes.botaoSalvar}>
                                Salvar
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            )}
        </>
    )
}
